// =============================================================================
// state
// =============================================================================
const state = {
  searchCustomerId: '',
  searchCustomerName: '',
  searchSelectNotPurchased: 'all',
  searchSelectNotMail: 'all',
  searchSelectPrefecture: 'all',
  checkList: [],
  checkCustomerList: [],
};
// =============================================================================
// getters
// =============================================================================
const getters = {
  search_customer_id: state => state.searchCustomerId,
  search_customer_name: state => state.searchCustomerName,
  search_select_not_purchased: state => state.searchSelectNotPurchased,
  search_select_not_mail: state => state.searchSelectNotMail,
  search_select_prefecture: state => state.searchSelectPrefecture,
  check_list: state => state.checkList,
  check_customer_list: state => state.checkCustomerList,
};
// =============================================================================
// actions
// =============================================================================
const actions = {
};
// =============================================================================
// mutations
// =============================================================================
const mutations = {
  set_search_customer_id (state, value) {
    state.searchCustomerId = value;
  },
  set_search_customer_name (state, value) {
    state.searchCustomerName = value;
  },
  set_search_select_not_purchased (state, value) {
    state.searchSelectNotPurchased = value;
  },
  set_search_select_not_mail (state, value) {
    state.searchSelectNotMail = value;
  },
  set_search_select_prefecture (state, value) {
    state.searchSelectPrefecture = value;
  },
  set_check_list (state, value) {
    state.checkList = value;
  },
  set_check_customer_list (state, value) {
    state.checkCustomerList = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
